import { createFileRoute } from "@tanstack/react-router";

import { EntryPage } from "../../../features/auth/EntryPage";

export const Route = createFileRoute("/_public/sign-up/")({
  component: function SignUp() {
    return <EntryPage intent="sign-up" />;
  },
});
